import { VenueIntegrationProduct } from '@models/venue/VenueIntegration'
import {
  getVenueIntegrationTimeSlotsDisplaySetting,
  updateVenueIntegrationTimeSlotsDisplaySetting,
} from '@services/venue/VenueIntegrationService'
import { Alert, Flex, Switch } from 'antd'
import { SwitchChangeEventHandler } from 'antd/es/switch'
import { FC, useEffect, useState } from 'react'

interface Props {
  venueSlug: string
  product: VenueIntegrationProduct
}

const VenueIntegrationDisplaySettings: FC<Props> = ({ venueSlug, product }) => {
  const [
    displaySlotsNotAttachedToSeatingArea,
    setDisplaySlotsNotAttachedToSeatingArea,
  ] = useState<boolean>()
  const [isLoading, setIsLoading] = useState<boolean>(true)

  const onSwitchValueChange: SwitchChangeEventHandler = (newValue) => {
    setIsLoading(true)
    updateVenueIntegrationTimeSlotsDisplaySetting(venueSlug, product, newValue)
      .then(() => {
        setDisplaySlotsNotAttachedToSeatingArea(newValue)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    setIsLoading(true)
    getVenueIntegrationTimeSlotsDisplaySetting(venueSlug, product)
      .then((data) => {
        setDisplaySlotsNotAttachedToSeatingArea(
          data.data.displaySlotsNotAttachedToSeatingArea
        )
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  return (
    <Flex>
      <Alert
        style={{ alignItems: 'center' }}
        title="Slots without seating area"
        description={
          'Some slots returned by the PMS are not linked to any seating area (Follow Shift Config). Should they be displayed on this page?'
        }
        action={
          <Switch
            loading={isLoading}
            checkedChildren={'Yes'}
            unCheckedChildren={'No'}
            checked={displaySlotsNotAttachedToSeatingArea}
            onChange={onSwitchValueChange}
          />
        }
      />
    </Flex>
  )
}

export { VenueIntegrationDisplaySettings }
